/**
 * Lệnh Bot — Set Limit navigation config.
 */

export const SET_LIMIT_ROUTE_NAME = 'LenhBotSetLimit'
export const SET_LIMIT_ITEM_ID    = 'lenh-bot-set-limit'
export const SET_LIMIT_LABEL      = 'Set Limit'
export const SET_LIMIT_TITLE      = 'Lệnh Bot · Set Limit'
